import { DateRangeCustomFilterEnum as r } from "../enum/date-range-filter-enum.mjs";
import { setDateWithTimezone as o } from "../../../utils/date-time-format.mjs";
const n = (t, s) => {
  const e = o("", s);
  return e.setHours(23, 59, 59, 999), [o(t, s), e];
}, a = (t) => {
  const s = o("", t);
  s.setHours(23, 59, 59, 999);
  const e = o("", t);
  return e.setMonth(e.getMonth() - 3), e.setHours(0, 0, 0, 0), [e, s];
}, m = (t, s) => ({
  slug: r.AllTime,
  handler: () => n(t, s)
}), c = (t) => ({
  slug: r.Last3Months,
  handler: () => a(t)
});
export {
  m as getDefaultCustomFilter,
  c as getLast3MonthsCustomFilter
};
